export const SEARCH_BY = "Search by name or keyword";
export const SEARCH_EXPERIENCES = "Search activities";
